import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const getRegionList = data => post(URL.GET_REGION_LIST, data);
export const getRegion = data => post(URL.GET_REGION, data);
export const addRegion = data => post(URL.ADD_NEW_REGION, data);
export const editRegion = data => post(URL.UPDATE_REGION, data);
export const deleteRegion = data => post(URL.DELETE_REGION, data);